import React, { useEffect, useRef, useState } from "react";
import AddVoucher from "./AddVoucher";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { CircularProgress, Skeleton } from "@mui/material";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import Messages from "../../../constants/Messages";
import ViewVoucher from "./ViewVoucher";
import { usePermission } from "../../../context/PermissionContext";
import useKeyboardTableNavigation from "../../../constants/useKeyboardTableNavigation";
import { ChevronRightIcon, DownloadIcon, SpreadSheetIcon } from "../../../constants/Icons";

const Voucher = ({ isActive }) => {
  const [isVoucherModalOpen, setVoucherModalOpen] = useState(false);
  const serverTime = GetServerLiveTime();
  const hasFetched = useRef(false);
  const { globelPopupOpen } = usePermission();
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isPreLoading, setPreLoading] = useState(true);
  const { isUser } = useAuth();
  const containerRef = useRef(null);
  const contentRefs = useRef([]);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  var obj = {
    label: isUser.title,
    value: isUser.storeId,
    stype: isUser.stype,
  };
  const [isVoucherData, setVoucherData] = useState([]);
  const [isSelectedStore, setSelectedStore] = useState(obj);
  const previousDate = new Date(serverTime.getTime() - 1000);
  const [fromDate, setFromDate] = useState(previousDate);
  const [toDate, setToDate] = useState(serverTime);
  const [openModel, setOpenModel] = useState(false);
  const [viewData, setViewData] = useState([]);

  const calculateDate = (baseDate, offsetDays) => {
    const resultDate = new Date(baseDate);
    resultDate.setDate(resultDate.getDate() + offsetDays);
    return resultDate;
  };

  const { totalDebit, totalCredit } = isVoucherData.reduce(
    (acc, item) => {
      if (item?.amountMode === "DEBIT") acc.totalDebit += item?.amount;
      else if (item?.amountMode === "CREDIT") acc.totalCredit += item?.amount;
      return acc;
    },
    { totalDebit: 0, totalCredit: 0 },
  );

  const getTrackModeColor = (trackMode) => {
    switch (trackMode?.toUpperCase()) {
      case "JOBCARD":
        return "bg-label-honey";
      case "invoice":
        return "bg-label-moon";
      default:
        return "bg-label-secondary";
    }
  };
  const fetchTrackMode = (trackMode) => {
    switch (trackMode?.toUpperCase()) {
      case "JOBCARD":
        return "Jobcard";
      case "PAYLATER":
        return "Paylater";
      default:
        return trackMode;
    }
  };

  const paymentMode = (mode) => {
    switch (mode?.toUpperCase()) {
      case "ONLINE":
        return "Online";
      case "CASH":
        return "Cash";
      case "CARD":
        return "Card";
      case "UPI":
        return "UPI";
      default:
        return mode;
    }
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // const handleFromDateChange = ([selectedDate]) => {
  //   setFromDate(selectedDate);
  //   const toDateValue = new Date(toDate);
  //   if (selectedDate > toDateValue) {
  //     const newFromDate = new Date(toDateValue.getTime() - 1000); // toDate - 1 day
  //     setFromDate(newFromDate);
  //     return;
  //   }

  //   const minToDate = calculateDate(selectedDate, -64);
  //   const maxToDate = new Date(
  //     Math.min(calculateDate(selectedDate, 64), serverTime)
  //   );
  //   if (toDateValue < minToDate || toDateValue > maxToDate) {
  //     setToDate(selectedDate);
  //   }
  // };

  // const handleToDateChange = ([selectedDate]) => {
  //   const fromDateValue = new Date(fromDate);
  //   const selectedToDate = new Date(selectedDate);

  //   if (selectedToDate.getTime() <= fromDateValue.getTime()) {
  //     const correctedFromDate = new Date(selectedToDate.getTime() - 1000); // toDate - 1 sec
  //     setFromDate(correctedFromDate);
  //   }
  //   setToDate(selectedDate);
  // };

  // const toDateMin = calculateDate(new Date(fromDate), -64);
  // const toDateMax = new Date(
  //   Math.min(calculateDate(new Date(fromDate), 64), serverTime)
  // );

  const handleFromDateChange = (newValue) => {
    if (!newValue) return;
    const selectedFrom = newValue.startOf("day");

    const maxAllowedTo = selectedFrom.add(64, "days");
    const finalMaxTo = maxAllowedTo.isAfter(dayjs(serverTime))
      ? dayjs(serverTime)
      : maxAllowedTo;

    setFromDate(selectedFrom.toDate());
    if (
      dayjs(toDate).isBefore(selectedFrom) ||
      dayjs(toDate).isAfter(finalMaxTo)
    ) {
      setToDate(finalMaxTo.toDate());
    }
  };

  const handleToDateChange = (newValue) => {
    if (!newValue) return;
    const selectedTo = newValue.endOf("day");

    if (selectedTo.isBefore(dayjs(fromDate))) {
      setFromDate(selectedTo.startOf("day").toDate());
    }
    setToDate(selectedTo.toDate());
  };

  const toDateMin = fromDate;
  const toDateMax = dayjs(fromDate).add(64, "day").isAfter(dayjs(serverTime))
    ? dayjs(serverTime)
    : dayjs(fromDate).add(64, "day");

  const handleOpenVoucher = () => {
    setVoucherModalOpen(true);
  };

  const handleVoucherClose = () => {
    setVoucherModalOpen(false);
  };

  const handleLitVoucher = async () => {
    // if (!validateForm()) return;
    setPreLoading(true);
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;

      var data = {
        storeid: isSelectedStore.value,
        fromdate: encodeURIComponent(
          DateConverter.convertToTimeZone(
            fromDate.toISOString(),
            isUser.timezone,
          ),
        ),
        todate: encodeURIComponent(
          DateConverter.convertToTimeZone(
            toDate.toISOString(),
            isUser.timezone,
          ),
        ),
      };

      let url = `module/voucher?startDate=${data.fromdate}&endDate=${data.todate}`;

      const response = await AxiosInstance.get(url);
      setVoucherData(response.data.results);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPreLoading(false);
      setBtnLoading(false);
    }
  };

  const handleViewClose = () => {
    setOpenModel(false);
  };
  const handleAddVoucher = async (addData) => {
    try {
      if (!checkNetwork()) return;
      const data = {
        title: addData?.title,
        customerId: addData?.customerData?._id,
        description: addData?.description,
        amount: CurrencyConverter.toSubunit(addData?.amount || 0, "INR"),
        amountMode: addData?.amountMode,
        taxpercentage: addData?.taxpercentage,
      };
      const response = await AxiosInstance.post("module/voucher", data);
      const result = response.data?.results;
      showAlert("success", Messages.SUCCESS.VOUCHER_ADDED);
      setVoucherData((prev) => [{ ...result }, ...prev]);
      handleVoucherClose();
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const openViewModel = async (id) => {
    await handleViewVoucher(id);
  };

  const handleViewVoucher = async (id) => {
    try {
      const response = await AxiosInstance.get(`module/voucher/${id}`);
      const result = response.data.results;
      setViewData(result);
      setOpenModel(true);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const exportToCSV = () => {
    if (!isVoucherData?.length) {
      showAlert("warning", "No data available to export");
      return;
    }

    // 1. Headers
    const headers = `S No,Voucher No,Date,Time,Description,Customer,Mode,Payment Mode,Debit,Credit`;

    const clean = (val) => (val ?? "").toString().replace(/[\r\n;]/g, " ");

    // 2. Rows

    const rows = isVoucherData
      ?.map((item, index) => {
        const row = [
          index + 1,
          clean(item?.voucherNumber),
          clean(
            DateConverter.ISOToDisplayFormat(
              item?.dateOfIssue,
              isUser?.timezone,
            ).date,
          ),
          clean(
            DateConverter.ISOToDisplayFormat(
              item?.dateOfIssue,
              isUser?.timezone,
            ).time,
          ),
          clean(
            `${item?.title} ${
              item?.taxInfo?.taxPercent !== 0
                ? `-${item?.taxInfo?.taxPercent}`
                : ""
            }${item?.description}`,
          ),
          clean(
            `${item?.customerInfo?.name ? item.customerInfo.name : ""}${
              item?.customerInfo?.phone ? "\n" + item.customerInfo.phone : "-"
            }`,
          ),
          clean(fetchTrackMode(item?.trackMode)),
          clean(paymentMode(item?.paymentMode)),
          clean(
            item?.amountMode === "DEBIT"
              ? CurrencyConverter.toCurrency(item?.amount || 0, "INR")
              : "",
          ),
          clean(
            item?.amountMode === "CREDIT"
              ? CurrencyConverter.toCurrency(item?.amount || 0, "INR")
              : "",
          ),
        ];
        return row.join(",");
      })
      .join("\n");

    // 3. Total Row
    const totalRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Total Amount",
      `${CurrencyConverter.toCurrency(totalDebit || 0, "INR")}`,
      `${CurrencyConverter.toCurrency(totalCredit || 0, "INR")}`,
      "",
    ].join(",");

    // 5. Combine everything
    const csvContent = [headers, rows, totalRow].join("\n");

    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `Voucher_${formatDate(new Date())}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useKeyboardTableNavigation({
    isActive,
    containerRef,
    modals: {
      isVoucherModalOpen,
      openModel,
      globelPopupOpen,
    },
    onEnter: openViewModel,
  });

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleLitVoucher();
  }, []);
  return (
    <>
      <div className="page-wrapper" ref={containerRef}>
        <div className="page-content">
          <div className="page-breadcrumb d-flex align-items-center paddingBottom">
            <div className="breadcrumb-title pe-3">Voucher</div>
            <div className="ms-auto d-flex gap-2">
              <button
                className="btn btn-sm btn-export dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <DownloadIcon/> Export
              </button>
              <ul className="dropdown-menu">
                <li>
                  <li>
                    <a className="dropdown-item" onClick={exportToCSV}>
                      <SpreadSheetIcon/>{" "}
                      <span className="icon-text">Excel (CSV)</span>
                    </a>
                  </li>
                </li>
              </ul>
            </div>
            {/* <div className="ms-auto d-flex gap-2">
              <div className="row">
                <div className="col-lg-12 col-12 d-flex justify-content-end ">
                  <button
                    type="button"
                    onClick={handleOpenVoucher}
                    className="btn btn-primary mt-2 mt-lg-0"
                  >
                    <i className="ng ng-ng-add-icon"></i> Add Voucher
                  </button>
                </div>
              </div>
            </div> */}
          </div>
          <div className="row py-0">
            <div className="col-lg-2">
              <div className="card">
                <div className="card-body">
                  <div className="row g-3">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="col-12">
                        <label className="form-label w-100">
                          From Date <span className="text-danger"> *</span>
                        </label>
                        <DatePicker
                          value={fromDate ? dayjs(fromDate) : null}
                          format="DD MMM YYYY"
                          onChange={handleFromDateChange}
                          maxDate={dayjs(serverTime)}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              className: "form-control",
                              inputProps: { readOnly: true },
                              onKeyDown: (e) => e.preventDefault(),
                              sx: {
                                "& .MuiInputBase-input": {
                                  cursor: "pointer",
                                },
                              },
                            },
                          }}
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label w-100">
                          To Date <span className="text-danger"> *</span>
                        </label>
                        <DatePicker
                          value={toDate ? dayjs(toDate) : null}
                          format="DD MMM YYYY"
                          onChange={handleToDateChange}
                          minDate={dayjs(toDateMin)}
                          maxDate={dayjs(toDateMax)}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              className: "form-control",
                              inputProps: { readOnly: true },
                              onKeyDown: (e) => e.preventDefault(),
                              sx: {
                                "& .MuiInputBase-input": {
                                  cursor: "pointer",
                                },
                              },
                            },
                          }}
                        />
                      </div>
                    </LocalizationProvider>

                    <div className="col-12">
                      <div className="d-grid">
                        {isBtnLoading ? (
                          <button
                            className="btn btn-primary pb-0 text-right"
                            disabled
                          >
                            <CircularProgress
                              size={22}
                              className="text-white"
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary"
                            id="salesreportbtn"
                            onClick={handleLitVoucher}
                          >
                            Generate <ChevronRightIcon/>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-10">
              <div className="card radius-10 mb-0">
                <div className="card-body px-0">
                  {/* <div className="row px-3">
                    <div className="col-lg-12 col-12 d-flex justify-content-end ">
                      <button
                        type="button"
                        onClick={handleOpenVoucher}
                        className="btn btn-primary mt-2 mt-lg-0"
                      >
                        <i className="ng ng-ng-add-icon"></i> Add Voucher
                      </button>
                    </div>
                  </div> */}
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="text-center">S.No</th>
                          <th className="text-center">Voucher No</th>
                          <th className="text-center">Date of Issue</th>
                          <th className="w-30 text-center">Description</th>
                          <th className="text-center">Customer</th>
                          <th className="text-center">Mode</th>
                          <th className="text-center">Payment Mode</th>
                          <th className="text-center">Debit</th>
                          <th className="text-center">Credit</th>
                          {/* <th className="text-center">Actions</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {isBtnLoading ? (
                          [...Array(9)].map((_, index) => (
                            <tr key={index}>
                              {[...Array(9)].map((__, i) => (
                                <td key={i} className="text-center">
                                  <Skeleton
                                    variant="text"
                                    width={i === 0 ? 50 : 120}
                                  />
                                </td>
                              ))}
                            </tr>
                          ))
                        ) : isVoucherData.length > 0 ? (
                          isVoucherData?.map((item, index) => (
                            <tr
                              key={item._id}
                              className="position-relative  cursor-poInter hover-row"
                              onClick={() => openViewModel(item._id)}
                              data-item={JSON.stringify(item._id)}
                            >
                              <td className="text-center paddingTopBottom">
                                {isVoucherData.length - index}
                              </td>
                              <td className="text-center">
                                <span
                                  className={`badge rounded-pill bg-label-deep-purple`}
                                >
                                  {item?.voucherNumber}
                                </span>
                              </td>
                              <td className="text-center">
                                <div className="d-flex flex-column">
                                  <span className="text-nowrap text-heading fw-medium">
                                    {
                                      DateConverter.ISOToDisplayFormat(
                                        DateConverter.convertToTimeZone(
                                          item.dateOfIssue,
                                          isUser.timezone,
                                        ),
                                      ).date
                                    }
                                  </span>
                                  <span className="text-nowrap">
                                    <small>
                                      {
                                        DateConverter.ISOToDisplayFormat(
                                          DateConverter.convertToTimeZone(
                                            item.dateOfIssue,
                                            isUser.timezone,
                                          ),
                                        ).time
                                      }
                                    </small>
                                  </span>
                                </div>
                              </td>
                              {/* <td className="text-wrap" width="280">
                                <div className="d-flex justify-content-between align-items-start">
                                  <div className="me-2">
                                    {item?.title} - &nbsp;
                                    <small className="badge rounded-pill bg-label-peace">
                                      {item?.taxInfo?.taxPercent}%
                                    </small>
                                    <div className="ms-0 fs-12 text-truncate-description">
                                      {item?.description}
                                    </div>
                                  </div>
                                </div>
                              </td> */}
                              <td className="text-truncate-description">
                                <div
                                  ref={(el) =>
                                    (contentRefs.current[index] = el)
                                  }
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 4,
                                    WebkitBoxOrient: "vertical",
                                  }}
                                >
                                  {/* {item?.title
                                      ? `${item?.title} - ${item?.description}`
                                      : "-"} */}
                                  {item?.title}{" "}
                                  {item?.taxInfo?.taxPercent !== 0 && (
                                    <>
                                      - &nbsp;
                                      <small className="badge rounded-pill bg-label-peace">
                                        {item?.taxInfo?.taxPercent}%
                                      </small>
                                    </>
                                  )}
                                  <div className="ms-0 fs-12 text-truncate-description">
                                    {item?.description}
                                  </div>
                                </div>
                              </td>
                              <td className="text-center">
                                <div className="d-flex flex-column">
                                  <span className="text-nowrap text-heading fw-medium">
                                    {item?.customerInfo?.name}
                                  </span>
                                  <span className="text-nowrap">
                                    <small>
                                      {item?.customerInfo?.phone
                                        ? `+91 ${item?.customerInfo?.phone}`
                                        : "-"}
                                    </small>
                                  </span>
                                </div>
                              </td>
                              <td className={`text-center`}>
                                <span
                                  className={`badge rounded-pill ${getTrackModeColor(
                                    item?.trackMode,
                                  )}`}
                                  style={{
                                    background: "#ffab1d",
                                    color: "#000",
                                    border: "none",
                                  }}
                                >
                                  {item?.trackMode
                                    ? fetchTrackMode(item?.trackMode)
                                    : ""}
                                </span>
                              </td>
                              <td className="text-center">
                                {item?.paymentMode
                                  ? paymentMode(item?.paymentMode)
                                  : ""}
                              </td>
                              <td className="text-center text-danger">
                                {item?.amountMode === "DEBIT"
                                  ? `-₹${CurrencyConverter.toCurrency(
                                      item?.amount || 0,
                                      "INR",
                                    )}`
                                  : ""}
                              </td>
                              <td className="text-center text-success">
                                {item?.amountMode === "CREDIT"
                                  ? `+₹${CurrencyConverter.toCurrency(
                                      item?.amount || 0,
                                      "INR",
                                    )}`
                                  : ""}
                              </td>
                              {/* <td className="text-center">
                                <div className="order-actions opacity-0 opacity-md-100">
                                  <>
                                    <button
                                      className="btn-label-primary shadow-none me-2"
                                      onClick={(e) =>{e.stopPropagation(); openViewModel(item._id)}}
                                    >
                                      <i className="bx bx-show"></i>
                                    </button>
                                  </>
                                </div>
                              </td> */}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="9"
                              className="text-center p-2 text-muted"
                            >
                              <span className="text-muted">
                                No Vouchers found in the store. add some
                                Vouchers to get started.
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                      <tbody>
                        <tr className="table-light">
                          <td colSpan={7} className="text-end fw-600">
                            Total Amount
                          </td>
                          <td className="text-end fw-600">
                            ₹
                            {CurrencyConverter.toCurrency(
                              totalDebit || 0,
                              "INR",
                            )}
                          </td>
                          <td className="text-end fw-600">
                            ₹
                            {CurrencyConverter.toCurrency(
                              totalCredit || 0,
                              "INR",
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isVoucherModalOpen && (
            <AddVoucher
              isActive={isActive}
              onClose={handleVoucherClose}
              onAdd={handleAddVoucher}
            />
          )}
          {openModel && (
            <ViewVoucher onClose={handleViewClose} viewData={viewData} />
          )}
        </div>
      </div>
    </>
  );
};

export default Voucher;
